<template>
  <div class="m-box">
    <p v-if="isUpKey==2" class="m-p x-font-color"><van-icon class="m-ice" name="passed" /> <span> 识别成功，点击下一步开始进行报名</span></p>
    <p v-if="isUpKey==1" class="m-p m-red"><van-icon class="m-ice" name="warning-o" /> <span> {{message}}</span></p>
    <div class="x-flex-between">
      <div class="m-img">
        <van-image class="m-ice"  fit="contain" :src="imgFit"/>
        <p class="m-text">证件照片</p>
      </div>
      <div class="m-img">
        <van-image class="m-ice"  fit="contain" :src="imgUrl"/>
        <p class="m-text">人脸照片</p>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    props:{
      imgUrl:{
        type:String,
        default:''
      }
    },
    components: {},
    data () {
      return {
        isUpKey:'',
        message:'',
        imgFit:''
      }
    },
    created () {
      this.getInfo()
    },
    methods: {
      //    获取个人信息
      getInfo () {
        this.http.postRequest({
          url: 'app/userInfo/getUserCardPhoto',
          msg: {idCardNum:this.$route.query.idCardNum},
          success: (res) => {
            if(res.msg){
              this.imgFit = res.msg
            }

          }
        })
      },
    },
    mounted () {

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/less" lang="less" scoped>
  @import "~@/assets/css/variable.less";
 .m-box{
    .m-p{
      text-align: center;
      font-size: 13px;
      margin-top: 40px;
      .m-ice{
        font-weight: bold;
      }
    }
   .m-red{
     color: #FB2927;
   }
   .x-flex-between{
     margin-top: 37px;
     .m-img{
        margin-bottom: 120px;
       .m-ice{
         width: 140px;
         height: 180px;
       }
       .m-text{
         margin-top: 15px;
         text-align: center;
       }
     }
   }
 }
</style>

